<template>
  <div class="NewsHeader">

    <div class="NewsHeader-content">

      <title-location class="NewsHeader-titleLocation"
        title="News"
        :title-route="{ name: 'news' }"
        :location="location"
        inline />

      <div class="NewsHeader-search">

        <news-search />

      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'NewsHeader',

  props: {
    location: {
      type: String
    }
  }
}
</script>

<style>
@import 'properties';

.NewsHeader {
  margin-top: 49px;
  padding-bottom: 24px;
  margin-bottom: 36px;
  border-bottom: 1px solid var(--c-grey-xxlt);
}

.NewsHeader-content {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.NewsHeader-titleLocation {
  margin-bottom: -2px;
}

.NewsHeader-search {
  display: none;

  @media (min-width: 600px) {
    display: block;
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// NewsHeader.vue?4d695c52